import { ActionStatus, buildActionType, StateStatus } from '../core';

const initialState = {
  data: {
    s3PresignedUrl: 0,
  },
  errors: null,
  status: StateStatus.NOT_INITIALIZED,
  version: 0,
  report: {
    newid: 0,
  },
};

const videoUpload =
  actionType =>
  (state = initialState, action) => {
    switch (action.type) {
      case buildActionType(actionType, ActionStatus.START):
        return { ...initialState, status: StateStatus.LOADING, version: state.version, entity: actionType.entity };

      case buildActionType(actionType, ActionStatus.DONE):
        return { status: StateStatus.LOADED, data: action.payload, entity: actionType.entity, version: +new Date(), report: action.report };

      case buildActionType(actionType, ActionStatus.FAILED):
        return { status: StateStatus.ERROR, errors: action.payload };

      case buildActionType(actionType, ActionStatus.RESET):
        return initialState;

      default:
        return state;
    }
  };

export { videoUpload };
